export const scrollToSection = (id, setActiveSection, setIsMenuOpen) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    if (setActiveSection) setActiveSection(id);
    if (setIsMenuOpen) setIsMenuOpen(false);
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const downloadCV = () => {
  const link = document.createElement('a');
  link.href = '/Ebraheem_Wannous_CV.pdf';
  link.download = 'Ebraheem_Wannous_CV.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
